// extracted by mini-css-extract-plugin
export default {"submitWrap":"AdminAddActivityTemplateForm_submitWrap__nG2wU"};